<template>
  <div>
    <template-chart :items="myItems" :yyyy="yyyy"></template-chart>
  </div>
</template>

<script>
export default {
  props: ['item', 'yyyy', 'mm', 'value', 'group', 'prev', 'plan'],
  computed: {
    headers () {
      var temp = []
      temp.push({ title: '在籍合計', id: 'calc_acts', key: 17, align: 'start', calc: 'ave', color: '#BBDEFB80' })
      temp.push({ title: 'DTS', id: 'calc_status', key: 9, align: 'start', calc: 'ave', color: '#D7CCC880' })
      temp.push({ title: '生徒面談', id: 'calc_status', key: 10, align: 'end', calc: 'ave', color: '#D7CCC880' })
      temp.push({ title: '保護者面談', id: 'calc_status', key: 11, align: 'end', calc: 'ave', color: '#D7CCC880' })
      return temp
    },
    myItems () {
      var temp = []
      var acts = []
      for (var i in this.headers) {
        var values = this.item[this.headers[i].id][this.yyyy][this.group].map(v => {
          return v[this.headers[i].key]
        })
        acts.push({
          'key': this.headers[i].key,
          'title': this.headers[i].title,
          'align': 'start',
          'values': values,
          'sum': (this.item[this.headers[i].id + '_sum'][this.yyyy][this.group][2][this.headers[i].key]).toFixed(),
          'prefix': '',
          'suffix': '',
          'color': this.headers[i].color,
          'calc': 'ave'
        })
      }
      var exec = []
      for (i in this.headers) {
        if (this.headers[i].key !== 17) {
          values = this.item[this.headers[i].id + '_exec'][this.yyyy][this.group].map(v => {
            return v[this.headers[i].key]
          })
          exec.push({
            'key': this.headers[i].key + this.headers[i].id + 'exec',
            'title': '',
            'align': 'end',
            'values': values,
            'sum': Math.floor(this.item[this.headers[i].id + '_exec_sum'][this.yyyy][this.group][2][this.headers[i].key]),
            'prefix': '',
            'suffix': '%',
            'color': '#D7CCC840',
            'calc': 'ave'
          })
        }
      }
      var prevs = []
      if (this.prev) {
        var prev = this.yyyy - 1
        if (prev >= 2018) {
          for (i in this.headers) {
            var id = this.value ? this.headers[i].id + '_diff' : this.headers[i].id
            if (this.headers[i].key !== 17) {
              id = this.value ? this.headers[i].id + '_exec' : this.headers[i].id + '_exec'
            }
            values = this.item[id][prev][this.group].map((v) => {
              return v[this.headers[i].key]
            })
            prevs.push({
              'key': 'prev' + this.headers[i].key,
              'title': this.value ? '昨年' : '昨年',
              'align': 'end',
              'values': values,
              'sum': Math.floor(this.item[id + '_sum'][prev][this.group][2][this.headers[i].key]),
              'prefix': '',
              'suffix': this.value ? '%' : (this.headers[i].key !== 17 ? '%' : ''),
              'color': '',
              'calc': 'ave'
            })
          }
        }
      }
      // var plans = []
      // if (this.plan) {
      //   id = this.value ? 'calc_status_plans_diff' : 'calc_plans_status'
      //   for (i in acts) {
      //     values = this.item[id][this.yyyy][this.group].map((v) => {
      //       return v[acts[i].key]
      //     })
      //     plans.push({
      //       'key': 'plans' + acts[i].key,
      //       'title': this.value ? '目標対' : '目標',
      //       'align': 'end',
      //       'values': values,
      //       'sum': this.item[id + '_sum'][this.yyyy][this.group][2][this.headers[i].key],
      //       'prefix': '',
      //       'suffix': this.value ? '%' : '',
      //       'color': '',
      //       'calc': 'ave'
      //     })
      //   }
      // }
      for (i in acts) {
        temp.push(acts[i])
        if (acts[i].key !== 17) {
          if (exec.length !== 0) {
            temp.push(exec[i - 1])
          }
        }
        if (prevs.length !== 0) {
          temp.push(prevs[i])
        }
      }
      return temp
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
